module.exports = __webpack_public_path__ + "static/img/14areaB_5.0f21214.png";


//////////////////
// WEBPACK FOOTER
// ./static/mycard/character2/14areaB_5.png
// module id = 1119
// module chunks = 1